import { h } from 'preact'
import DropdownControl from '../../dropdown/DropdownControl'
import ButtonControl from '../../button-control'
import AppliedFilter from '../../articles/AppliedFilter'

function normalizeItems (items: [], onFilterChange: () => void) {
  return items.map((item: any) => {
    return {
      title: item,
      value: item,
      onClick: onFilterChange
    }
  })
}

interface FilterSelector {
  type: string,
  selected?:{
    name: string
  },
  items: [],
  onFilterChange: () => void
}

const SimpleFilterSelector = ({ type, selected, items, onFilterChange }: FilterSelector) => {
  return <DropdownControl
    align='adjust'
    trigger={<ButtonControl title={selected ? <AppliedFilter type={type} name={selected.name} /> : `Filter by ${type}`} class={`filter qa-${type}-filter`} icon='arrowDropdown' />}
    items={normalizeItems(items, onFilterChange)}
  />
}

export default SimpleFilterSelector
